import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { ConteneurDto, UtilisateurDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-utilisateur-select',
  templateUrl: './utilisateur-select.component.html',
  styleUrls: ['./utilisateur-select.component.css']
})
export class UtilisateurSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  @Select(ControlPanelStore.utilisateursEC$) utilisateurs$: Observable<UtilisateurDto[]>;

  @Input() width: number;
  @Input() widthPopUp: number = 400;

  @Input() Utilisateurs: UtilisateurDto[] = null;
  @Input() utilisateurId: number;
  @Input() titleNull: string = null;
  @Output() utilisateurIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  Selectedutilisateur: UtilisateurDto = null;
  ColumnName = [];

  c: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'LastName',
        'FirstName'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['LastName']);
      this.ColumnName.push(translations['FirstName']);
    });
  }

  ngOnInit() {
    if (this.utilisateurId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.utilisateurId));
    }

    if (!this.Utilisateurs) {
      this.c = this.utilisateurs$.subscribe((res:UtilisateurDto[]) => {
        if (res != null) {
          this.Utilisateurs = res;
        }
      });
    }
    else {
      if (this.titleNull && !this.Utilisateurs.find(p => p.Id == 0)) {
        this.Utilisateurs.unshift({ Id: 0, Nom: "" });
      }
      if (!this.utilisateurId) {
        this.utilisateurId = 0;
      }
     }
  }

  getDisplayText = (utilisateur) => {
    return `${utilisateur.Nom} ${utilisateur.Prenom}`;
  }

  ngOnDestroy() {
    this.c?.unsubscribe();
  }

  updateInfo(event) {
    this.utilisateurId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.utilisateurId;
    if (!!this.cell && this.InitId !== this.utilisateurId) {
      this.cell.setValue(this.utilisateurId);
    }
    this.utilisateurIdChange.emit(this.utilisateurId);

    if(this.utilisateurId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.utilisateurId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
